import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var OptionDetail = Backbone.Model.extend( {

    defaults: {
        'shortName': null,
        'longName': null,
        'selected': false,
        'available': true,
        'disabled': false,
        'optionColors': []
    },

    initialize: function () {
        app.mediator = app.mediator || _.extend( {}, Backbone.Events );
        this.listenTo( app.mediator, 'reset:options', this.reset );
        this.listenTo( this, 'invalidated', this.unselect );
    },

    select: function () {
        // only one item option can be the primarySelection at any given time,
        // reset attribute on all options when a select change is detected
        if ( app.appController.primaryOption ) {
            app.appController.primaryOption.set( 'primaryOption', false );
        }
        // save reference to last selected option and use as primary selection to refer ui decisions
        this.set( 'primaryOption', true );
        app.appController.primaryOption = this;

        // defers to collection for setting :selected attribute to ensure that only one item is selected
        // for it's collection at one time
        this.trigger( 'select:one', this );
    },

    unselect: function () {
        this.set( 'selected', false );
        this.trigger( 'unselected' );
    },

    toggleAvailable: function ( isAvailable ) {
        this.set( 'available', isAvailable );
    },

    toggleDisabled: function ( isDisabled ) {
        this.set( 'disabled', isDisabled );
    },

    reset: function () {
        this.set( {available: true, selected: false, primaryOption: false} );
    }

} );

export default OptionDetail;
